import script from "./AllFilesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AllFilesModal.vue?vue&type=script&setup=true&lang=js"

import "./AllFilesModal.vue?vue&type=style&index=0&id=1b88ee63&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b88ee63"]])

export default __exports__